// src/services/inviteService.js
// Thin wrapper around backend invite endpoints.
import { getBackendUrl } from '../utils/apiUrl';

const API_BASE = getBackendUrl();

async function authFetch(path, options = {}) {
  // Auth token is stored under 'authToken' by AuthContext
  const token = localStorage.getItem('authToken');
  return fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : undefined,
      ...(options.headers || {}),
    },
  });
}

export const inviteService = {
  async generateInvite(type = 'CRNA_REFERRAL', prefillData = null) {
    const res = await authFetch('/invites', {
      method: 'POST',
      body: JSON.stringify({ type, prefillData }),
    });
    if (!res.ok) throw new Error('Failed to generate invite');
    return res.json();
  },
  async listAllInvites() {
    const res = await authFetch('/invites/all');
    if (!res.ok) throw new Error('Failed to fetch all invites');
    return res.json();
  },

  async listMyInvites() {
    const res = await authFetch('/invites');
    if (!res.ok) throw new Error('Failed to fetch invites');
    return res.json();
  },
};

export default inviteService;
